import React from 'react';
import "./menu.css";

import {
  Link,
  Redirect
} from 'react-router-dom';
import STRINGS from './../../data/language/language';
import CLOSE from "../../img/x.svg";

class Menu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      strings:STRINGS[window.LANGUAGE],
    }
  }

  closeMenu(e) {
    e.preventDefault();

    const menu = document.getElementById('menu');
    menu.classList.remove("open");
  }

  render(){
    const data = window.localStorage.getItem('loginData');

    let dashboard;
    let videos;
    let exercicios;
    let blocos_diarios;
    let blocos_semanais;
    let planilhas;
    let treinoDomiciliar;
    let clientes;
    let planos;
    let usuarios;
    let relatorios;
    let perguntas;
    let termos_uso;
    let politicaPrivacidade;
    let sobre;
    let faq;
    let mensagens;
    let cielo;
    let pagSeguro;
    let treinoHome;

    if(data){
      const dataObj = JSON.parse(data);
      const permissions = dataObj.permissions;

      if(permissions['dashboard']){
        dashboard = <LinkItem url="/area-restrita/dashboard" icon="fas fa-chart-bar" txt="Dashboard"></LinkItem>;
      }

      if(permissions['videos']){
        videos = <LinkItem url="/area-restrita/videos" icon="fas fa-play-circle" txt="Vídeos"></LinkItem>;
      }

      if(permissions['exercicios']){
        exercicios = <LinkItem url="/area-restrita/exercicios" icon="fas fa-child" txt="Exercícios"></LinkItem>;
      }

      if(permissions['blocos-diarios']){
        blocos_diarios =  <LinkItem url="/area-restrita/blocos" icon="fas fa-list-ul" txt="Blocos diários"></LinkItem>;
      }

      if(permissions['blocos-semanais']){
        blocos_semanais =    <LinkItem url="/area-restrita/blocos-planilha" icon="far fa-clipboard" txt="Blocos semanais"></LinkItem>;
      }

      if(permissions['20-modelos']){
        planilhas = <LinkItem url="/area-restrita/planilhas-treino" icon="fas fa-clipboard" txt="20 modelos"></LinkItem>;
      }

      if(permissions['treino-domiciliar'] || permissions['treino-dominiciliar']){
        treinoDomiciliar = <LinkItem url="/area-restrita/treino-domiciliar" icon="fas fa-home" txt="Treino domiciliar"></LinkItem>;
        treinoHome = <LinkItem url="/area-restrita/treino-home" icon="fas fa-home" txt="Treino Home"></LinkItem>;
      }

      if(permissions['clientes']){
        clientes = <LinkItem url="/area-restrita/clientes" icon="fas fa-users" txt="Clientes"></LinkItem>;
      }

      if(permissions['planos']){
        planos = <LinkItem url="/area-restrita/planos" icon="fas fa-tasks" txt="Planos"></LinkItem>;
      }

      if(permissions['usuarios']){
        usuarios = <LinkItem url="/area-restrita/usuarios" icon="fas fa-users-cog" txt="Usuários"></LinkItem>;
      }

      if(permissions['relatorios']){
        relatorios =   <LinkItem url="/area-restrita/relatorios" icon="fas fa-chart-pie" txt="Relatórios"></LinkItem>;
      }

      if(permissions['perguntas-frequentes']){
        perguntas =  <LinkItem url="/area-restrita/perguntas-frequentes" icon="fas fa-comment-dots" txt="Perguntas frequentes"></LinkItem>;
      }

      if(permissions['termos-de-uso']){
        termos_uso =  <LinkItem url="/area-restrita/termos-de-uso" icon="fas fa-copyright" txt="Termos de uso"></LinkItem>;
      }

      if(permissions['politica-privacidade']){
        politicaPrivacidade =  <LinkItem url="/area-restrita/politica-privacidade" icon="fas fa-copyright" txt="Política de privacidade"></LinkItem>;
      }

      if(permissions['sobre']){
        sobre = <LinkItem url="/area-restrita/sobre" icon="fas fa-comment" txt="Sobre"></LinkItem>;
      }

      if(permissions['faq']){
        //faq =   <LinkItem url="/area-restrita/faq" icon="fas fa-question-circle" txt="Faq"></LinkItem>;
      }

      if(permissions['mensagens']){
        mensagens = <LinkItem url="/area-restrita/mensagens" icon="fas fa-comments" txt="Mensagens"></LinkItem>;
      }

      if(permissions['dashboard']){
        pagSeguro = <a href='https://pagseguro.uol.com.br/' target='_blank' className='btpagseguro'>Pagseguro<i className='fas fa-external-link-alt icon-external'></i></a>;
        cielo = <a href='https://minhaconta2.cielo.com.br/login/' target='_blank' className='btpagseguro'>Cielo<i className='fas fa-external-link-alt icon-external'></i></a>;
      }

    }

    return (
        <div className="menu" id='menu'>
          <div className='menu-overlay'><a href='#' className='bt-close-menu' onClick={this.closeMenu}><img src={CLOSE} /></a></div>
          <div className="menu-scroll">
            <div className="menu-inner">
              <ul>
                {dashboard}
                {videos}
                {exercicios}
                {blocos_diarios}
                {blocos_semanais}
                {planilhas}
                {treinoDomiciliar}
                {treinoHome}
                {planos}
                {clientes}
                {faq}
                {sobre}
                {usuarios}
                {relatorios}
                {perguntas}
                {termos_uso}
                {politicaPrivacidade}
                {mensagens}
                {/*<LinkItem url="/area-restrita/planos-alimentares" icon="fas fa-newspaper" txt="Planos alimentares"></LinkItem>*/}
                {/*<LinkItem url="/area-restrita/campanhas" icon="fas fa-newspaper" txt="Campanhas"></LinkItem>*/}
                {/*<LinkItem url="/area-restrita/financeiro" icon="fas fa-money-bill" txt="Financeiro"></LinkItem>*/}
                {/*<LinkItem url="/area-restrita/ebook" icon="fas fa-book-open" txt="E-book"></LinkItem>*/}
                <br /><br />
                {cielo}
                <br />
                {pagSeguro}
                <br /><br />
              </ul>
            </div>
          </div>
        </div>
    );
  }
}

const refCallback = () => {
  const menu = document.getElementById('menu');
  menu.classList.remove("open");
}

const LinkItem = ({...props}) => {
  var _class = ' link-menu--icon--material '+props.icon;
  return(
    <li className="link-menu--item">
      <Link to={props.url}  onClick={refCallback}>
        <div className="link-menu">
          <span className="link-menu--icon">
              <i className={_class}></i>
        </span>
          <span className="link-menu--txt">{props.txt}</span>
          <div className="clear"></div>
        </div>
      </Link>
    </li>
  )
}

    ;

export default Menu;



// WEBPACK FOOTER //
// ./src/classes/menu/Menu.js